import React from 'react'
//import { Segment } from 'semantic-ui-react'
import ChatBot from 'react-simple-chatbot'
//import '../App.css'
import LeftSidebar from '../components/Navbar/LeftSidebar/LeftSidebar'

const Chat = () => {
    const steps = [

        {
    
          id: "Greet",
    
          message: "Hello, Welcome to AI Chatbox",
    
          trigger: "Done",
    
        },
    
        {
    
          id: "Done",
    
          message: "Please enter your name!",
    
          trigger: "waiting1",
    
        },
    
        {
    
          id: "waiting1",
    
          user: true,
    
          trigger: "Name",
    
        },
    
        {
    
          id: "Name",
    
          message: "Hi {previousValue}, Please select programming language",
    
          trigger: "language",
    
        },
    
        {
    
          id: "language",
    
          options: [
    
            {
    
              value: "React",
    
              label: "React",
    
              trigger: "React",
    
            },
    
            { value: "Angular", label: "Angular", trigger: "Angular" },
            { value: "Javascript", label: "Javascript", trigger: "Javascript" },
    
          ],
    
        },
    
        {
    
          id: "React",
    
          message:
    
            "React is a declarative, efficient, and flexible JavaScript library for building user interfaces.",
    
          trigger: "More",
    
        },

        {
    
          id: "More",
    
          message:
    
            "If you want to know more kindly visit https://reactjs.org or directly contact me on my email-id aggarwalan939@gmail.com",
    
          end: true,
    
        },

        {
    
          id: "Angular",
    
          message:
    
            "AngularJS is a toolset for building the framework most suited to your application development. It is fully extensible and works well with other libraries.",
    
          trigger: "More1",
    
        },
    
        {
    
          id: "More1",
    
          message:
    
          "If you want to know more kindly visit https://angular.org or directly contact me on my email-id aggarwalan939@gmail.com",
    
          end: true,
    
        },

        {
    
          id: "Javascript",
    
          message:
    
            "JavaScript is a dynamic programming language that's used for web development, in web applications, for game development, and lots more.",
    
          trigger: "More2",
    
        },
    
        {
    
          id: "More2",
    
          message:
    
          "If you want to know more kindly visit https://javascript.org or directly contact me on my email-id aggarwalan939@gmail.com",
    
          end: true,
    
        },
    
      ]; 
    
    
    
    return (
        <div className='home-container-1'>
            <LeftSidebar />
            <div className='home-container-2' style={{ marginTop: "120px", marginLeft: "150px"}}>
                <ChatBot steps = {steps}/>
            </div>
        </div>

    )
    
}

export default Chat